import { useParams } from "react-router-dom";
import { usePageTitle } from "@/hooks/use-page-title";
import { FormList } from "@/components/forms/FormList";
import { FormEditor } from "@/components/forms/FormEditor";

export function FormsPage() {
  usePageTitle("Forms");
  const { formId } = useParams<{ formId: string }>();

  if (formId) {
    return <FormEditor formId={formId} />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Forms</h1>
        <p className="text-muted-foreground">
          Create and manage forms for clock-in and clock-out workflows
        </p>
      </div>
      <FormList />
    </div>
  );
}
